import { fetchJson } from "../utils/app";

// O backend aplica o GUID da sessao em ambas as consultas.
export async function listarCertificados() {
  const data = await fetchJson("/api/certificados");
  return data.certificados;
}

export async function obterCertificado(idCertificado) {
  const data = await fetchJson("/api/certificados/" + encodeURIComponent(String(idCertificado)));
  return data.certificado;
}

// Consulta publica do link compartilhado; funciona sem sessao.
export async function validarCertificado(codigo) {
  const data = await fetchJson("/api/certificados/validar/" + encodeURIComponent(String(codigo)));
  return data.certificado;
}

// Monta o link publico que o usuario pode compartilhar fora do sistema.
export const linkValidacaoCertificado = (codigo) =>
  window.location.origin + "/validar/" + encodeURIComponent(String(codigo));

// Envia apenas o curso; o backend obtem a identidade pela sessao autenticada.
export async function registrarCertificado(courseId) {
  const data = await fetchJson("/api/certificados", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_curso: Number(courseId) }),
  });
  return data.certificado;
}
